module.exports = __webpack_public_path__ + "static/media/V404_wall.9129180e.png";